module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/introduction01-76174fe78494a1ce8183691ffba00b88.png";